import { ChangeDetectorRef, Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { EnpsComponent } from '@common/components/base/enps-component';
import { SearchBoxComponent } from '@common/components/search-box/search-box';
import { GlobalTablesService } from '@common/services/global-tables-service';
import { LanguageSettings } from '@common/services/language-settings';
import { LayoutState } from '@common/services/layout-state';
import { VisualStateService } from '@common/services/visual-state-service';
import { FilterTypes } from '@src/suite/common/enums/filter-types';
import { AppService } from '@suite/app.service';
import { DataStore } from '@suite/common/data-models/data-store/data-store';
import { UsersResults } from '@suite/common/data-models/search-results/users-result';
import { NomWebServicesJson } from '@suite/common/services/nom-web-services-json';
import { TeamMembersService } from '@suite/common/services/team-members-service';
import { GlobalRoles } from '@suite/common/utils/util';

@Component({
    selector: 'st-filter-manage-team-members',
    templateUrl: './filter-manage-team-members.html',
    styleUrls: ['./filter-manage-team-members.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        class: '.st-filter-manage-team-members',
    },
})
export class FilterManageTeamMembersComponent extends EnpsComponent implements OnInit {
    public filterMemberStatus: Array<{ StatusNumber: number; StatusName: string }> = [
        { StatusNumber: 0, StatusName: 'Active' },
        { StatusNumber: 1, StatusName: 'Disabled' },
    ];

    public selectedTeam: string;
    public selectedRole: string;
    public selectedStatus: number;
    public roles = [];

    public staffIDs: Array<string> = [];

    public get groupByField(): string {
        return UsersResults.groupByField;
    }

    public get sortByField(): any {
        return UsersResults.sortByField;
    }
    @ViewChild('searchBox') public searchBox: SearchBoxComponent;
    @Input() public type: number;
    public filterTypes = FilterTypes;

    constructor(
        public appService: AppService,
        public layoutState: LayoutState,
        public languageSettings: LanguageSettings,
        public nomWebServicesJson: NomWebServicesJson,
        public visualStateService: VisualStateService,
        public globalTablesService: GlobalTablesService,
        public teamMembersService: TeamMembersService,
        protected changeDetectorRef: ChangeDetectorRef
    ) {
        super();
    }

    public async ngOnInit() {
        const res = await this.teamMembersService.getTeamMembers();
        if (res.status) {
            this.proccessSecurityForFilter(res.data.security);
        }
    }

    private proccessSecurityForFilter(security: Array<any>) {
        if (security) {
            const roles = JSON.parse(JSON.stringify(security));
            roles.unshift(GlobalRoles.SUPERVISOR_ITEM);
            roles.unshift(GlobalRoles.SERVER_MANAGER_ITEM);

            this.roles = roles;
        }
    }

    public async filterTeamMembers() {
        Promise.resolve().then(async () => {
            const res = await this.teamMembersService.getTeamMembers(this.selectedTeam, this.selectedRole, this.selectedStatus);
            DataStore.usersResults = res.data.userResults;
            DataStore.usersResults.rebuildGroups(this.groupByField, this.sortByField);
        });
    }
}
